import { IDENTIFICATION_TYPES, INCOME_SOURCES } from "../constants/contact"

/**
 * Given an identification type identity return a material icon to display.
 * @param type An identification type to map to an icon.
 */
export const contactIcon = (buyerType) => {
    if (!buyerType || (buyerType.length <= 0)) {
        return 'person'
    }
    
    switch (buyerType.toLowerCase()) {
        case 'business':
        case 'entity':
            return 'business'
        case 'government':
        case 'firm':
        case 'trust':
            return 'balance'
        case 'non-profit':
            return 'people'
        case 'agricultural':
            return 'agriculture'
        case 'individual':
        default:
            return 'person'
    }
}

/**
 * Given an identification type identity return a material icon to display.
 * @param type An identification type to map to an icon.
 */
export const identIcon = (typeId) => {
    if (!typeId || (typeId <= 0)) {
        return 'badge'
    }

    if (!IDENTIFICATION_TYPES || (IDENTIFICATION_TYPES.length <= 0)) {
        return 'badge'
    }

    const matched = IDENTIFICATION_TYPES.find((type) => type.id == typeId)
    if (!matched) {
        return 'badge'
    }

    switch (matched.type.toLowerCase()) {
        case 'us military':
            return 'military_tech'
        case 'us immigration / department of justice':
        case 'department of state':
        case 'department of homeland security':
            return 'local_police'
        default:
            return 'badge'
    }
}

/**
 * Given an address type return a material icon to display.
 * @param type An address type to map to an icon.
 */
export const addyIcon = (type) => {
    if (!type) {
        return 'home'
    }

    switch (type.toLowerCase()) {
        case 'mailing':
            return 'mail'
        case 'billing':
            return 'paid'
        case 'work':
            return 'business'
        default:
            return 'home'
    }
}

/**
 * Given a communincation type return a material icon to display.
 * @param type A commuinication type to map to an icon.
 */
export const commIcon = (type) => {
    if (!type) {
        return 'web'
    }

    switch (type.toLowerCase()) {
        case 'phone':
            return 'phone'
        case 'email':
            return 'email'
        case 'facebook':
        default:
            return 'web'
    }
}

/**
 * Given an income type incomeity return a material icon to display.
 * @param type An income type to map to an icon.
 */
export const incomeIcon = (type) => {
    if (!type || (type.length <= 0)) {
        return 'attach_money'
    }

    if (!INCOME_SOURCES || (INCOME_SOURCES.length <= 0)) {
        return 'attach_money'
    }

    const matched = INCOME_SOURCES.find((source) => source == type)
    if (!matched) {
        return 'attach_money'
    }

    switch (matched.toLowerCase()) {
        case 'investments':
            return 'show_chart'
        case 'rental homes':
            return 'home_work'
        default:
            return 'attach_money'
    }
}

/**
 * Given a buyer type return a material icon to display.
 * @param type A buyer type to map to an icon.
 */
export const buyerIcon = (type) => {
    if (!type) {
        return 'person'
    }

    switch (type.toLowerCase()) {
        case 'business':
        case 'entity':
            return 'business'
        case 'government':
            return 'account_balance'
        case 'trust':
            return 'balance'
        case 'non-profit':
            return 'volunteer_activism'
        case 'agricultural':
            return 'agriculture'
        default:
            return 'person'
    }
}

/**
 * Determine an tab icon to show based on the payment category.
 * @param category The payment category.
 */
export const paymentCategoryIcon = (category) => {
    if (!category || (category.length <= 0)) {
        return 'monetization_on'
    }

    switch(category.toLowerCase()) {
        case 'deposit':
        case 'initial down':
        case 'deferred down':
        case 'mv loan':
            return 'directions_car'
        case 'service':
            return 'car_repair'
        default:
            return 'monetization_on'
    }
}

/**
 * Given an inventory reconditioning type return a material icon to display.
 * @param type An inventory reconditioning type to map to an icon.
 */
export const reconTypeIcon = (type) => {
    if (!type) {
        return 'car_repair'
    }

    switch (type.toLowerCase()) {
        case 'parts only':
            return 'miscellaneous_services'
        case 'auction':
            return 'gavel'
        case 'transportation':
            return 'local_shipping'
        case 'labor only':
        case 'parts & labor':
        default:
            return 'car_repair'
    }
}

/**
 * Given an integration category return a material icon to display.
 * @param category An integration category to map to an icon.
 */
export const integrationIcon = (category) => {
    if (!category) {
        return 'link'
    }

    switch (category.toLowerCase()) {
        case 'gps':
            return 'gps_fixed'
        case 'ach':
            return 'account_balance'
        case 'card':
            return 'credit_card'
        case 'consumer':
            return 'people'
        case 'titling':
            return 'commute'
        default:
            return 'link'
    }
}

/**
 * Given an user recent resource return a material icon to display.
 * @param resource A user recent resource to map to an icon.
 */
export const recentIcon = (resource) => {
    if (!resource) {
        return 'link'
    }

    switch (resource.toLowerCase()) {
        case 'contacts':
            return 'people'
        case 'sales':
            return 'sell'
        case 'inventory':
            return 'directions_car'
        case 'collections':
            return 'paid'
        case 'reports':
            return 'analytics'
        default:
            return 'link'
    }
}

/**
 * Given a payment receipt category return an icon to display
 * @param {strinng} category A payment receipt item category.
 * @returns 
 */
export const receiptIcon = (category) => {
    if (!category || (category.length <= 0)) {
        return 'monetization_on'
    }

    switch(category.toLowerCase()) {
        case 'mv loan':
            return 'directions_car'
        case 'service':
            return 'car_repair'
        case 'deposit':
        case 'initial down':
        case 'deferred down':
            return 'receipts'
        default:
            return 'monetization_on'
    }
}